import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Pabrik',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Pabrik',
        href: '/adm/pabrik',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_pabrik',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'id_pabrik',
        label: 'ID',
        sortable: true,
      },
      {
        key: 'kode_pabrik',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'logo',
        label: 'Logo',
      },
      {
        key: 'nama_pabrik',
        label: 'Nama Pabrik',
      },
      {
        key: 'telp',
        label: 'Telp',
      },
      {
        key: 'email',
        label: 'Email',
      },
      {
        key: 'alamat',
        label: 'Alamat',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      dist_code: '',
      dist_company: '',
      dist_address: '',
      dist_email: '',
      dist_phone: '',
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changePabrik(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchPabrik(context, params = null) {
    let result = await ApiGetRequest(`pabrik`, params);
    return !result.error ? result.data.object : [];
  },

  async getAllPabrik({ commit }) {
    commit('changePabrik', {
      loading: true,
    });

    let result = await ApiGetRequest(`pabrik`);
    commit('changePabrik', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListPabrik({ commit, state }) {
    commit('changePabrik', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_pabrik: data.id_pabrik ? data.id_pabrik : null,
    };

    let result = await ApiGetRequest(`pabrik`, params);
    commit('changePabrik', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailPabrik({ commit }, payload = null) {
    commit('changePabrik', {
      loading: true,
    });

    let result = await ApiGetRequest(`pabrik/${payload.id}`);
    commit('changePabrik', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadLogoPabrik({ commit, state }, payload) {
    commit('changePabrik', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`upload-image`, payload);
    commit('changePabrik', {
      loading: false,
    });

    if (!result.error) {
      commit('changePabrik', {
        form: {
          ...data.form,
          logo: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changePabrik', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`pabrik/import`, {
      items: data.import_form || [],
    });

    commit('changePabrik', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createPabrik({ commit, state, dispatch }) {
    commit('changePabrik', {
      loading: true,
    });

    let result = await ApiPostRequest(`pabrik`, state.data.form);
    commit('changePabrik', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updatePabrik({ commit, state, dispatch }, payload = null) {
    commit('changePabrik', {
      loading: true,
    });

    let result = await ApiPutRequest(`pabrik/${payload.id}`, state.data.form);

    commit('changePabrik', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deletePabrik({ commit, dispatch }, payload = null) {
    commit('changePabrik', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`pabrik/${payload.id}`);
    commit('changePabrik', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
